import create from 'zustand'
import { persist } from 'zustand/middleware'

const initialState = {
  accessToken: null,
  consecutiveTokenRefreshFailures: 0,
  isAppUser: false,
  hasChangedEmail: false,
  hasChangedPassword: false,
  registrationCompleted: false,
  step: 0,
  triggerCompletionSidebar: false,
  isFetchingProfileData: false,
  isFetchingHomeScreenDetails: false,
  triggerGetProfileData: false,
  triggerTokenRefresh: false,
  isUpdatingStore: false,
  isFetchingCouponList: false,
  isFetchErrorCouponList: false,
  errorMessageCredit: null,
  errorMessageProfile: null,
  timeStampCardOrder: null,
  personalInput: {}
}

// in case we need fields that should be saved outside of crmAttributes object
const nonCrmFields = []

export const useLoyaltyStore = create(
  persist(
    set => ({
      ...initialState,
      addPersonalData: input => {
        set(state => ({
          personalInput: {
            ...input
          }
        }))
      },
      updatePersonalField: (field, value) => {
        set(state => {
          // handles fields that should not be saved inside crmAttributes
          if (nonCrmFields.includes(field)) {
            return {
              personalInput: {
                ...state.personalInput,
                [field]: value
              }
            }
          }

          return {
            personalInput: {
              ...state.personalInput,
              crmAttributes: {
                ...state.personalInput?.crmAttributes,
                [field]: value
              }
            }
          }
        })
      },
      resetLoyaltyStore: () => {
        set({ ...initialState })

        const storageName = 'loyalty-storage'

        sessionStorage.setItem(
          storageName,
          JSON.stringify({ state: initialState, version: 0 })
        )
      },
      incrementTokenRefreshFailures: () =>
        set(state => ({
          consecutiveTokenRefreshFailures:
            state.consecutiveTokenRefreshFailures + 1
        })),
      resetTokenRefreshFailures: () =>
        set({ consecutiveTokenRefreshFailures: 0 })
    }),
    {
      name: 'loyalty-storage',
      getStorage: () => sessionStorage
    }
  )
)

export const useLoyaltyTempStore = create(set => ({
  changedValuesSidebar: {},
  updateChangedValuesSidebar: (fieldName, value) =>
    set(state => ({
      changedValuesSidebar: {
        ...state.changedValuesSidebar,
        [fieldName]: value
      }
    })),
  clearChangedValuesSidebar: () => set({ changedValuesSidebar: {} })
}))

export const useLoyaltyCardStore = create(
  persist(
    () => ({
      timeStampCardOrder: {}
    }),
    {
      name: 'card-order-storage'
    }
  )
)
